import React, { useState } from 'react'
import { Classes, Dialog } from '@blueprintjs/core'
import { Flex, Icon, Toaster } from '@ui'
import MeasurementInput from 'components/AdminFloorPlan/components/MeasurementInput'
import css from './areaSection.module.scss'
import api, { ISpaceCapacity } from '@api'
import { ApolloError } from 'apollo-client'
import useFloor from '@providers/mapProvider/floorProvider/provider'
import { EvoGhostButton, EvoButton } from '@ui/buttons/EvoButton'
import { Button } from '@runeffective/evo-design-system'

export interface AreaSectionPopupDialogProps {
  setIsAreaeOpen: (para: boolean) => void
  isAreaeOpen: boolean
  selectedSpaces: string[]
}

export default function AreaSectionPopup({
  setIsAreaeOpen,
  isAreaeOpen,
  selectedSpaces,
}: AreaSectionPopupDialogProps) {
  const [btnDisabled, setBtnDisabled] = useState(true)
  const [selectedValue, setSelectedValue] = useState(0)
  const floor = useFloor()

  function resetState() {
    setBtnDisabled(true)
    setSelectedValue(0)
    setIsAreaeOpen(false)
  }

  function onClickSubmit() {
    const data: ISpaceCapacity[] | { measurements: number; id: string }[] = []
    selectedSpaces.forEach(function (space) {
      data.push({ measurements: Math.abs(selectedValue), id: space })
    })

    api.space
      .updateSpacez(data)
      .then(() => {
        Toaster.success({ message: 'Area updated successfully' })
        floor.reloadMap?.()
      })
      .catch((error: ApolloError) => {
        Toaster.fail({ error })
      })
    resetState()
  }

  return (
    <>
      <Dialog
        style={{ paddingBottom: '0px' }}
        isOpen={isAreaeOpen}
        className={css.dialogWidth}
        transitionDuration={200}
        isCloseButtonShown={true}
        canOutsideClickClose={false}
        onClose={() => resetState()}
      >
        <div className={css.empList}>
          <Button
            style={{ position: 'absolute', top: '5px', right: '10px' }}
            aria-label="single icon button"
            onClick={() => {
              resetState()
            }}
            size="default"
            layout="borderless"
          >
            <Icon name="close" />
          </Button>

          <div>
            <div className={css.dialogHeader}> Assigned Area </div>
          </div>
          <div>
            <div className={css.labelText}>
              Set the area for each of the selected spaces. After completing this action, all the
              selected spaces will have the same area.
            </div>
            <div className={css.paddingTop}>
              <MeasurementInput
                value={selectedValue}
                onChange={(data) => {
                  setSelectedValue(data.target.value)
                  setBtnDisabled(false)
                }}
              />
            </div>
          </div>
          <div className={Classes.DIALOG_FOOTER} style={{ marginTop: 10 }}>
            <div className={Classes.DIALOG_FOOTER_ACTIONS}>
              <Flex style={{ gap: '8px' }} direction="row" justify="space-between">
                <Button
                  layout="borderless"
                  onClick={() => {
                    resetState()
                  }}
                  size="default"
                >
                  Cancel
                </Button>
                <Button
                  disabled={btnDisabled}
                  layout="primary"
                  onClick={() => onClickSubmit()}
                  size="default"
                >
                  Update
                </Button>
              </Flex>
            </div>
          </div>
        </div>
      </Dialog>
    </>
  )
}
